import React from 'react';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import OrderOverTimeModal from 'Components/OrderOverTimeModal/OrderOverTimeModal';

interface IProps {
  minutes: number;
  seconds: number;
  isOverTime: boolean;
  onCancel: () => void;
}

const OrderCountDown: React.SFC<IProps> = ({
  minutes,
  seconds,
  isOverTime,
  onCancel,
}) => (
  <div className='order-count-down'>
    <OrderOverTimeModal 
      isVisible={ isOverTime } 
      onClose={ onCancel } 
    />
    <div className='min'>
      { minutes >= 0 ? minutes : 0 } 
      <FormattedText
        displayName='min'
        formattedName='global.min'
      />
    </div>
    <div className='sec'>
      { seconds >= 0 ? seconds : 0 }
      <FormattedText
        displayName='sek'
        formattedName='global.sec'
      />
    </div>
  </div>
);

export default OrderCountDown;


// WEBPACK FOOTER //
// ./src/components/OrderCountDown/OrderCountDown.tsx